import React from "react";

export const ComingSoon = () => {
  return (
    <div
      style={{ width: "100%", justifyContent: "center", alignItems: "center" }}
    >
      <h1 style={{ marginBottom: "0px" }}>Coming Soon</h1>

      <img src="./images/misc/SmartComp2025.png" />
    </div>
  );
};
